<template>
  <!-- <router-link
    :to="{ name: 'keino', params: { mean_id: data.slug } }"
    tag="div"
    class="item card py-2"
  > -->
  <div class="item card py-3 px-4">

    <div class="content">
      <div class="gallery-card-info">
        <div class="flex justify-start align-center mb-1">
          <div :class="setClass(data.ref)" class="mean-icon flex flex-center">
            <i class="material-icons">{{ this.data.categoryIcon }}</i>
          </div>
          <span class="font-8 color-grey-d1 lheight-9">{{ this.data.categoryTitle }}</span>
        </div>
        <router-link :to="{ name: 'keino', params: { mean_id: data.slug } }" tag="h4" class="break-initial mb-1 txt-bold pointer">
          {{ data.title }} <i class="material-icons link font-11 color-grey-l1" style="transform: rotate(45deg);">link</i>
        </router-link>
        <!-- <h4>{{ data.title }} <i class="material-icons link font-11 color-grey-l1" style="transform: rotate(45deg);">link</i></h4> -->
        <span class="block mt-1 font-8-5 color-grey-d1">kohteet: <span class="font-8 txt-bold color-black">{{ this.usedInExamples }} kpl</span></span>

      </div>

      <div v-html="data.teaser" class="gallery-card-text text-content-html mt-3" style="font-size: 0.85rem;"></div>

      <div class="h-1"></div> <!-- for visual reasons -->

    </div>
    <slot></slot>

  </div>
  <!-- </router-link> -->
</template>

<script>
// import { mapState } from 'vuex'
export default {
  name: 'GitemMeans',

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    /* ...mapState([
      'vuexExamples'
    ]), */

    usedInExamples () {
      let meansInExamples = this.$store.state.examples.map(e => e.addedMeans).map(ee => ee.map(eee => eee.slug))
      let lista = []
      meansInExamples.forEach(a => {
        if (a.includes(this.data.slug)) {
          lista.push({ a })
        }
      })
      return lista.length
    }
  },

  methods: {
    setClass (category) {
      return ['group-' + category]
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";
</style>
